import React from "react";
import logoIcon from "../assets/logo.png";
import logoText from "../assets/image.png";
import nmoLogo from "../assets/nmologo.jpg";

function Footer() {
  return (
    <footer className="w-full bg-[#F8E6E3] [direction:rtl] border-t border-[#e5e5e5] text-[#333] font-['Cairo']">
      <div
        className="
          max-w-[1200px]
          mx-auto
          px-[30px]
          pt-[45px]
          pb-[35px]
          flex
          justify-between
          items-start
          gap-[70px]

          max-[768px]:flex-col
          max-[768px]:gap-[32px]
          max-[768px]:px-[24px]
          max-[768px]:pt-[36px]
          max-[768px]:pb-[28px]

          max-[480px]:px-[16px]
          max-[480px]:pt-[28px]
          max-[480px]:pb-[20px]
          max-[480px]:gap-[24px]
        "
      >
        {/* طبختنا */}
        <div className="w-[30%] max-[768px]:w-full">
          <div className="flex items-center gap-[6px] mb-[12px]">
            <img
              src={logoText}
              alt="طبختنا"
              className="w-[80px] h-auto"
            />

            <img
              src={logoIcon}
              alt=""
              aria-hidden="true"
              className="w-[27px] h-[27px] object-contain"
            />
          </div>

          <p className="m-0 text-[#555] text-[13px] leading-[1.9] max-[480px]:text-[12px]">
            وصفات بيتية بسيطة، مكونات واضحة
            <br />
            بالتكلفة وتوصيل سريع لباب البيت.
          </p>
        </div>

        {/* التطبيقات */}
        <div
          className="
            flex
            flex-col
            items-start
            gap-[13px]
            max-[768px]:w-full
          "
        >
          <h3 className="m-0 mb-[4px] text-[15px] font-semibold text-[#222]">
            التطبيقات
          </h3>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            طبخ
          </a>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            تخطيط
          </a>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            سريعة
          </a>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            رئيسية
          </a>
        </div>

        {/* روابط سريعة */}
        <div
          className="
            flex
            flex-col
            items-start
            gap-[13px]
            max-[768px]:w-full
          "
        >
          <h3 className="m-0 mb-[4px] text-[15px] font-semibold text-[#222]">
            روابط سريعة
          </h3>

          <a
            href="#home"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            الرئيسية
          </a>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            الأقسام
          </a>

          <a
            href="#categories"
            className="text-[#555] text-[13px] no-underline hover:text-[#d40c1a]"
          >
            الطبخات
          </a>
        </div>

        {/* تواصل معنا */}
        <div
          className="
            flex
            flex-col
            items-start
            gap-[13px]
            max-[768px]:w-full
          "
        >
          <h3 className="m-0 mb-[4px] text-[15px] font-semibold text-[#222]">
            تواصل معنا
          </h3>

          {/* Email */}
          <div className="flex items-center gap-[8px] text-[#555] text-[13px]">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path
                d="M12.9984 4.13477L7.68529 7.51905C7.505 7.62377 7.3002 7.67893 7.0917 7.67893C6.8832 7.67893 6.6784 7.62377 6.49811 7.51905L1.17969 4.13477"
                stroke="#D40C1A"
                strokeWidth="1.18187"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.8165 2.36328H2.36156C1.70883 2.36328 1.17969 2.89242 1.17969 3.54515V10.6364C1.17969 11.2891 1.70883 11.8182 2.36156 11.8182H11.8165C12.4693 11.8182 12.9984 11.2891 12.9984 10.6364V3.54515C12.9984 2.89242 12.4693 2.36328 11.8165 2.36328Z"
                stroke="#D40C1A"
                strokeWidth="1.18187"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <a
              href="mailto:hello@tabkhtna.com"
              className="text-[#555] no-underline"
            >
              hello@tabkhtna.com
            </a>
          </div>

         {/* Phone */}
<div className="flex items-center gap-[8px] text-[#555] text-[13px]">

  {/* Phone Icon */}
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    style={{ transform: "scaleX(-1)" }}
  >
    <path
      d="M7.58179 9.20054C7.70383 9.25659 7.84133 9.2694 7.97163 9.23685C8.10192 9.2043 8.21724 9.12834 8.29859 9.02149L8.50838 8.7467C8.61846 8.59992 8.76122 8.48078 8.92533 8.39873C9.08943 8.31667 9.27039 8.27396 9.45387 8.27396H11.2267C11.5401 8.27396 11.8407 8.39847 12.0624 8.62012C12.284 8.84176 12.4085 9.14237 12.4085 9.45583V11.2286C12.4085 11.5421 12.284 11.8427 12.0624 12.0643C11.8407 12.286 11.5401 12.4105 11.2267 12.4105C8.40561 12.4105 5.70009 11.2898 3.7053 9.29505C1.71051 7.30025 0.589844 4.59473 0.589844 1.77367C0.589844 1.46022 0.714362 1.1596 0.936006 0.937959C1.15765 0.716315 1.45826 0.591797 1.77171 0.591797H3.54452C3.85797 0.591797 4.15858 0.716315 4.38023 0.937959C4.60187 1.1596 4.72639 1.46022 4.72639 1.77367V3.54647C4.72639 3.72995 4.68367 3.91091 4.60162 4.07502C4.51956 4.23913 4.40043 4.38188 4.25364 4.49197L3.97708 4.69939C3.8686 4.78222 3.79213 4.90006 3.76068 5.03288C3.72922 5.1657 3.74472 5.30532 3.80453 5.42801C4.61215 7.06837 5.94042 8.39498 7.58179 9.20054Z"
      stroke="#D40C1A"
      strokeWidth="1.18187"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

  {/* Phone Number */}
  <a
    href="tel:+963944398853"
    dir="ltr"
    className="text-[#555] no-underline"
  >
    +963944398853
  </a>

</div>

          {/* Location */}
          <div className="flex items-center gap-[8px] text-[#555] text-[13px]">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path
                d="M7.44982 12.8816C8.54896 11.9325 11.8222 8.85966 11.8222 5.90912C11.8222 4.65532 11.3241 3.45286 10.4375 2.56629C9.55093 1.67971 8.34848 1.18164 7.09467 1.18164C5.84086 1.18164 4.63841 1.67971 3.75184 2.56629C2.86526 3.45286 2.36719 4.65532 2.36719 5.90912C2.36719 8.85966 5.64038 11.9325 6.73952 12.8816C6.84191 12.9586 6.96656 13.0002 7.09467 13.0002C7.22278 13.0002 7.34743 12.9586 7.44982 12.8816Z"
                stroke="#D40C1A"
                strokeWidth="1.18187"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.09312 7.68038C8.07221 7.68038 8.86592 6.88666 8.86592 5.90757C8.86592 4.92848 8.07221 4.13477 7.09312 4.13477C6.11402 4.13477 5.32031 4.92848 5.32031 5.90757C5.32031 6.88666 6.11402 7.68038 7.09312 7.68038Z"
                stroke="#D40C1A"
                strokeWidth="1.18187"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span>توصيل داخل المدينة وضواحيها</span>
          </div>
        </div>
      </div>

      {/* Made by NMO */}
      <div
        className="
          w-full
          border-t
          border-[#e5e5e5]
          py-[13px]
          px-[65px]
          box-border
          flex
          items-center
          justify-end

          max-[480px]:py-[12px]
          max-[480px]:px-[30px]
        "
      >
        <div
          className="
            flex
            items-center
            [direction:ltr]
            gap-[7px]
            text-[12px]
            text-[#555]

            max-[480px]:gap-[6px]
            max-[480px]:text-[11px]
          "
        >
          <span
            className="
              text-[#555]
              text-[12px]
              font-medium
              whitespace-nowrap

              max-[480px]:text-[11px]
            "
          >
            Made by NMO
          </span>

          <span className="text-[#aaa] text-[12px]">
            |
          </span>

          <a
            href="https://nmo.business"
            target="_blank"
            rel="noopener noreferrer"
            className="
              text-[#555]
              text-[12px]
              font-medium
              underline
              underline-offset-[3px]
              whitespace-nowrap
              transition-opacity
              duration-200
              hover:text-[#555]
              hover:opacity-[0.65]

              max-[480px]:text-[11px]
            "
          >
            nmo.business
          </a>

          <span
            className="
              w-[24px]
              h-[24px]
              flex
              items-center
              justify-center
              overflow-hidden
              ml-[2px]

              max-[480px]:w-[22px]
              max-[480px]:h-[22px]
            "
          >
            <img
              src={nmoLogo}
              alt="NMO"
              className="
                w-[30px]
                h-[30px]
                object-cover
                object-center
                block
                mix-blend-multiply

                max-[480px]:w-[27px]
                max-[480px]:h-[27px]
              "
            />
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
